var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCreatePage(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 15.75H12M10.5 15.75C9.8787 15.75 9.375 15.2463 9.375 14.625V12.75H9M10.5 15.75H7.5M9 12.75H8.625V14.625C8.625 15.2463 8.1213 15.75 7.5 15.75M9 12.75V15.75M7.5 15.75H6",
    stroke: "#00424B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 2.25H6C3.87868 2.25 2.81802 2.25 2.15901 2.90901C1.5 3.56802 1.5 4.62868 1.5 6.75V8.25C1.5 10.3713 1.5 11.4319 2.15901 12.091C2.81802 12.75 3.87868 12.75 6 12.75H12C14.1213 12.75 15.1819 12.75 15.841 12.091C16.5 11.4319 16.5 10.3713 16.5 8.25V6.75C16.5 4.62868 16.5 3.56802 15.841 2.90901C15.1819 2.25 14.1213 2.25 12 2.25Z",
    stroke: "#00424B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreatePage);
export default __webpack_public_path__ + "static/media/create-page.b6c21ea89033beae27fe27a30b44d41c.svg";
export { ForwardRef as ReactComponent };